import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { CSS_MAP } from "./constants";

const HdfStyled = ({ hdfId, children }) => (
  <Fragment>
    {CSS_MAP[hdfId] ? (
      <Helmet>
        <link rel="stylesheet" type="text/css" href={`/assets/css/hdf/${CSS_MAP[hdfId]}`} />
      </Helmet>
    ) : null}
    {children}
  </Fragment>
);

HdfStyled.propTypes = {
  hdfId: PropTypes.string,
  children: PropTypes.node,
};

export default HdfStyled;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/HdfStyled.js